import { render, staticRenderFns } from "./AdminAdd.vue?vue&type=template&id=738cd603&scoped=true&"
import script from "./AdminAdd.vue?vue&type=script&lang=ts&"
export * from "./AdminAdd.vue?vue&type=script&lang=ts&"
import style0 from "./AdminAdd.vue?vue&type=style&index=0&id=738cd603&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738cd603",
  null
  
)

export default component.exports